import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { useController, Control, FieldValues, Path } from "react-hook-form";

interface FormInputProps<T extends FieldValues>
  extends Omit<InputProps, "name"> {
  name: Path<T>;
  label: string;
  control: Control<T, any, any>;
  isRequired?: boolean;
}

export function FormInput<T extends FieldValues>({
  name,
  label,
  control,
  isRequired = false,
  ...inputProps
}: FormInputProps<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <Input {...field} {...inputProps} className="placeholder:text-gray-500" />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
}
